import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type ITask from './interfaces/ITask';
import type ITaskManagementSlice from './interfaces/ITaskManagementSlice';

export const initialState: ITaskManagementSlice = {
  tasks: [],
};

export const tasksManagementSlice = createSlice({
  name: 'tasksManagement',
  initialState,
  reducers: {
    setTasks: (state, { payload }: PayloadAction<ITask[]>) => {
      state.tasks = payload;
    },
    resetState: () => initialState,
  },
});

export const { setTasks, resetState } = tasksManagementSlice.actions;

export default tasksManagementSlice.reducer;
